<template>
  <page-header></page-header>

  <div class="innerPageBanner partnerBanner">
    <div class="container-sm">
      <div class="row">
        <div class="col-md-12">
          <div class="innerBannerText">
            <h1>DROIT D’AUTEUR</h1>
            <p style="text-align: justify">
              AVERTISSEMENT: © Postmedia Network Canada Corp. 2010-2021. Tous
              droits réservés. Ce site Web est la propriété de Postmedia Network
              Canada Corp. (« Postmedia »). Toute l’information et tout le
              contenu ou autre matériel (collectivement, le « contenu ») se
              trouvant dans les pages de ce site Web sont protégés par les lois
              sur le droit d’auteur du Canada et d’autres pays. Sauf indication
              contraire, personne n’est autorisé à copier, redistribuer,
              reproduire ou republier sous quelque forme que ce soit le contenu
              des pages de ce site Web. Cela inclut la reproduction électronique
              par « téléversement » ou « téléchargement » ou toute autre
              transmission sur Internet ou tout autre système informatique local
              ou international. Toute violation des droits de Postmedia peut
              entraîner une action en justice appropriée.<br />
              Si vous souhaitez obtenir de plus amples informations sur
              l’utilisation autorisée ou la licence de reproduction ou de
              republication d’un contenu, veuillez adresser votre demande à
              webmaster@postmedia.com. Postmedia décline toute responsabilité
              quant aux conséquences, quelles qu’elles soient, qui pourraient
              résulter de toute reproduction ou utilisation non autorisée du
              contenu de ce site Web.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <page-footer></page-footer>
</template>

<script>
import PageFooter from "../fr/PageFooter.vue";
import PageHeader from "../fr/PageHeader.vue";

export default {
  name: "track-your-shipment",
  components: {
    PageFooter,
    PageHeader,
  },
  beforeMount() {
    scroll(0, 0);
  },
};
</script>
